import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: { label: string; value: string }[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const getListRequestLeaveConfigSlice = createSlice({
  name: "getListRequestLeaveConfig",
  initialState,
  reducers: {
    getListRequestLeaveConfigStart: (state, action: PayloadAction<object>) => {
      state.status = ReduxStateType.LOADING;
    },
    getListRequestLeaveConfigSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getListRequestLeaveConfigFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetListRequestLeaveConfig: () => {
      return { ...initialState };
    },
  },
});

export const {
  getListRequestLeaveConfigStart,
  getListRequestLeaveConfigSuccess,
  getListRequestLeaveConfigFailed,
  resetListRequestLeaveConfig,
} = getListRequestLeaveConfigSlice.actions;

export default getListRequestLeaveConfigSlice.reducer;
